import { render } from "./SecondMenu.vue?vue&type=template&id=a1f9da32"
import script from "./SecondMenu.vue?vue&type=script&lang=js"
export * from "./SecondMenu.vue?vue&type=script&lang=js"

import "./SecondMenu.vue?vue&type=style&index=0&id=a1f9da32&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__